module.exports = __webpack_public_path__ + "img/avatar_24.2165e02d.svg";